"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignInWithProviderButton = void 0;
const ButtonNew_1 = require("root/src/client/v2/common/components/form/ButtonNew");
const providers_1 = require("root/src/shared/@types/providers");
const useSignInWithProvider_1 = require("root/src/client/web/auth/hooks/useSignInWithProvider");
const tiktok_logo_svg_1 = __importDefault(require("root/src/client/public/icons/tiktok-logo.svg"));
const twitch_logo_svg_1 = __importDefault(require("root/src/client/public/icons/twitch-logo.svg"));
const youtube_social_icon_red_png_1 = __importDefault(require("root/src/client/public/youtube_social_icon_red.png"));
const image_1 = __importDefault(require("next/image"));
const iconMap = {
    [providers_1.Provider.Twitch]: twitch_logo_svg_1.default,
    [providers_1.Provider.Google]: youtube_social_icon_red_png_1.default,
    [providers_1.Provider.TikTok]: tiktok_logo_svg_1.default,
};
function SignInWithProviderButton(props) {
    const { provider, providerLabel, onSignIn } = (0, useSignInWithProvider_1.useSignInWithProvider)({
        provider: props.provider,
        isLinking: props.isLinking,
    });
    return (<ButtonNew_1.ButtonNew onClick={onSignIn} className="bg-dark-google border-dark-googleBorder border-[1px] rounded p-2 flex justify-center" variant={ButtonNew_1.ButtonNewVariant.PrimaryNoHover} disabled={props.disabled} type="button">
			<ProviderIcon provider={provider}/>
			<span className="mx-2 text-white font-medium text-sm">Sign in with {providerLabel}</span>
		</ButtonNew_1.ButtonNew>);
}
exports.SignInWithProviderButton = SignInWithProviderButton;
function ProviderIcon(props) {
    const icon = iconMap[props.provider];
    return (<image_1.default className="object-contain" src={icon.src} unoptimized height={20} width={20}/>);
}
